/**
 * components/stepper.tsx — the design's joined −/value/+ control (channel caps).
 */
import React from 'react';
import { View, Pressable } from 'react-native';
import { LightColors as C, FontFamily as FF, FontWeight as FW } from '../theme/theme';
import { Txt } from './ui';

export interface StepperProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
}

const Stepper: React.FC<StepperProps> = ({ value, onChange, min = 1, max = 5 }) => {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));

  const Btn: React.FC<{ sign: string; onPress: () => void; side: 'l' | 'r' }> = ({ sign, onPress, side }) => (
    <Pressable
      onPress={onPress}
      style={{
        width: 26,
        height: 26,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: C.line,
        backgroundColor: C.card,
        borderTopLeftRadius: side === 'l' ? 5 : 0,
        borderBottomLeftRadius: side === 'l' ? 5 : 0,
        borderTopRightRadius: side === 'r' ? 5 : 0,
        borderBottomRightRadius: side === 'r' ? 5 : 0,
      }}
    >
      <Txt size={15} color={C.ink2}>
        {sign}
      </Txt>
    </Pressable>
  );

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <Btn sign="−" onPress={dec} side="l" />
      <View
        style={{
          height: 26,
          minWidth: 34,
          alignItems: 'center',
          justifyContent: 'center',
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: C.line,
          backgroundColor: C.card,
        }}
      >
        <Txt weight={FW.semibold} style={{ fontFamily: FF.mono }}>
          {value}
        </Txt>
      </View>
      <Btn sign="+" onPress={inc} side="r" />
    </View>
  );
};

export default Stepper;
